import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Status from './Status'
import Body from './Body'
import Image from './Image'

import styles from './Card.module.scss'

const Card = ({ focused, slim, children, className }) => {
  const slots = {
    status: null,
    image: null,
    body: null,
  }

  React.Children.forEach(children, child => {
    if (!child) return
    switch (child.type) {
      case Status: {
        slots.status = child
        break
      }
      case Image: {
        slots.image = child
        break
      }
      case Body: {
        slots.body = child
        break
      }
      default:
        break
    }
  })

  return (
    <div
      className={classnames(
        styles.listingCard,
        focused && styles.focused,
        slim && styles.slim,
        className
      )}
      tabIndex='-1'
    >
      {/* order is important, status should render after image, so it overlays the image w/o z-index */}
      {slots.image}
      {slots.status}
      {slots.body}
    </div>
  )
}

Card.defaultProps = {
  slim: false,
}

Card.propTypes = {
  children: PropTypes.any,
  focused: PropTypes.bool,
  slim: PropTypes.bool,
  className: PropTypes.bool,
}

export default Card
